"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var ServiceOverviewContainer = document.querySelector('.service-line-overview');
  if (ServiceOverviewContainer) {
    var readMoreTrigger = document.querySelector('.service-line-overview__read-more');
    var hiddenContent = document.querySelector('.service-line-overview__content');
    var videoContent = document.querySelector('.service-line-overview__right');
    var topContent = document.querySelector('.service-line-overview__inner-top');
    readMoreTrigger.addEventListener('click', function (event) {
      hiddenContent.classList.add('full-content');
    });
    if (!videoContent) {
      topContent.classList.add('full-content');
    }
    var mediaQuery = window.matchMedia('(min-width: 576px)');
    var heightContent = document.querySelector('.service-line-overview__wrapper').offsetHeight;
    if (mediaQuery.matches) {
      if (heightContent < 230) {
        readMoreTrigger.classList.add('hide');
      }
    } else {
      if (heightContent < 350) {
        readMoreTrigger.classList.add('hide');
      }
    }
  }
});